import { Field, Form, FormikProvider, useFormik, FieldArray, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { FaEye, FaDownload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { downloadBase64Pdf } from "../../CommonUtils/ImagesBase64";
import { CollegeReport } from "../UniversityScreens/CollegeReport";
import { FaCheck } from "react-icons/fa";
import { openScrutinyPdfInNewTab } from "../UniversityScreens/ScrutinityPdfGeneration";
import { openChangeOfManagementPdfInNewTab } from "../UniversityScreens/PdfForChangeofManagement";
import NewCollegeApplPreview from "../NewCollegeApplPreview";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { ERROR_MSG, MOBILE_VALIDATION } from "../../CommonUtils/contextVariables";
import allowNumbersOnly, { getServiceFullName, handlePaste } from "../../CommonUtils/CommonValidations";
import Select from "react-select";
import { GetNocServices } from "../../Reducers/AffiliationCommonservice";
import { useSelector } from "react-redux";


export default function InspectionStatus() {
  const NocServicesOptions = useSelector((state) => state?.commonMastersReducer?.nocservices);

  // ─── All useState hooks first ───────────────────────────────────────────────
  const [verificationType, setVerificationType] = useState("");
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfBase64, setPdfBase64] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showShiftingModal, setShowShiftingModal] = useState(false);
  const [selectedCollCode, setSelectedCollCode] = useState(null);
  const [pdfData, setPdfData1] = useState({});
  const [societyName, setSocietyName] = useState([]);
  const [getAccomidation, setAccom] = useState([]);
  const [managementData, setManagementData] = useState([]);
  const [nocdata, setNocdata] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [pdfData2, setPdfData2] = useState({});
  const [pdfData3, setPdfData3] = useState({});
  const [ScrutinyPdfData, setScrutinyPdfData] = useState({});
  const [ScrutinyPdfData1, setScrutinyPdfData1] = useState({});
  const [getOverallData, setOverallData] = useState([]);
  const [getSurvey, setSurvey] = useState([]);
  const [shiftAddr, setShiftAddr] = useState([]);
  const [inspstatus, setInspStatus] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [polyData, setPolyData] = useState([]);
  const [assignedTeamData, setAssignedTeamData] = useState({ online: "", physical: "" });
  const [InstName, setInstName] = useState("");
  const [collcode, setcollcode] = useState("");
  const [teamMembersdata, setTeamMembersdata] = useState([]);
  const [teamStaffsdata, setTeamStaffdata] = useState({});
  const [conData, setConData] = useState([]);

  let navigate = useNavigate();
  const userId = sessionStorage.getItem("user_id");

  const scrutinyValidationSchema = Yup.object().shape({
    scrutinyTeam: Yup.string().required("Required"),
  });

  const committeeValidationSchema = Yup.object().shape({
    nonScrutinyModalFields: Yup.array().of(
      Yup.object().shape({
        university: Yup.string().test("university-required-only-second", ERROR_MSG, function (value) {
          const match = this.path.match(/\d+/); // NOSONAR
          const index = match ? Number(match[0]) : -1;
          if (index === 1) {
            return !!(value && value.trim());
          }
          return true;
        }),
        officerName: Yup.string().required(ERROR_MSG),
        designation: Yup.string().required(ERROR_MSG),
        cfmsIdNo: Yup.string().required(ERROR_MSG),
        conClgName: Yup.string().required(ERROR_MSG),
        fromDateInsp: Yup.string().required(ERROR_MSG),
        toDateInsp: Yup.string().required(ERROR_MSG),
        mobileNo: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid mobile number"),
      }),
    ),
  });

  // ─── Main table formik ───────────────────────────────────────────────────────
  const degreeUniFormik = useFormik({
    initialValues: { collegesTableData: [], nocType: "eop" },
    onSubmit: () => { },
  });

  // ─── Modal formik — schemas are defined above so no reference error ──────────
  const degreeUniFormikAssignInspFormik = useFormik({
    initialValues: {
      collegesTableData: [],
      nocType: "",
      nonScrutinyModalFields: Array.from({ length: 3 }, () => ({
        university: "",
        officerName: "",
        designation: "",
        gmail: "",
        cfmsIdNo: "",
        conClgName: "",
        collegeAssigned: "",
        fromDateInsp: "",
        toDateInsp: "",
        mobileNo: "",
      })),
      scrutinyTeam: "",
    },
    validationSchema: verificationType === "online_scrutiny" ? scrutinyValidationSchema : committeeValidationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: (values) => {
      handleFinalSubmit(values, collcode, verificationType);
    },
  });

  // ─── Helper functions ────────────────────────────────────────────────────────

  const handleClose = () => setShowModal(false);

  function GetTeamMembersData(code) {
    let url = config?.url?.FAC_URL + "getTeammembers/" + code;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") setTeamMembersdata(res?.data?.data);
      else setTeamMembersdata([]);
    });
  }

  function GetTeamStaffsData(ubCode, index) {
    let url = `${config.url.FAC_URL}getTeamStaffData?ubCode=${ubCode}`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setTeamStaffdata((prev) => ({ ...prev, [index]: res?.data?.data }));
      } else {
        setTeamStaffdata((prev) => ({ ...prev, [index]: [] }));
      }
    });
  }

  function getConvenerData() {
    let url = config?.url?.FAC_URL + "getConvynordata";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") setConData(res?.data?.data);
      else setConData([]);
    });
  }

  function getPolyData() {
    let url = `${config.url.FAC_URL}getpolyprincipaldata`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") setPolyData(res?.data?.data);
      else setPolyData([]);
    });
  }

  const handleOfficerChange = (index, selectedName) => {
    const selectedFaculty = (teamStaffsdata[index] || []).find((item) => item.fac_name === selectedName);
    degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].officerName`, selectedName);
    if (selectedFaculty) {
      degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].gmail`, selectedFaculty.email_id || "");
      degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].cfmsIdNo`, selectedFaculty.cfms_id || "");
      degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].mobileNo`, selectedFaculty.contact || "");
      degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].conClgName`, selectedFaculty.univ_name || "");
      degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].designation`, selectedFaculty.designation || "");
    }
  };

  // ─── handleSubmitWithTouch — uses modal formik ───────────────────────────────
  const handleSubmitWithTouch = () => {
    const touchedFields = {};
    degreeUniFormikAssignInspFormik.values.nonScrutinyModalFields.forEach((_, index) => {
      if (index === 1) {
        touchedFields[`nonScrutinyModalFields[${index}].university`] = true;
      }
      touchedFields[`nonScrutinyModalFields[${index}].officerName`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].designation`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].gmail`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].cfmsIdNo`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].conClgName`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].collegeAssigned`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].fromDateInsp`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].toDateInsp`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].mobileNo`] = true;
    });
    degreeUniFormikAssignInspFormik.setTouched(touchedFields, true);
    degreeUniFormikAssignInspFormik.submitForm(); // ✅ correct formik
  };

  // ─── handleFinalSubmit ───────────────────────────────────────────────────────
  const handleFinalSubmit = (values, collCode, verificationTypeParam) => {
    const teamData = values.nonScrutinyModalFields
      .map((item, index) => {
        if (!item.officerName) return null;
        return {
          verificationType: verificationTypeParam,
          teamType: index === 1 ? "teamHead" : "teamMember",
          officerName: item.officerName ?? "",
          designation: item.designation ?? "",
          gmail: item.gmail ?? "",
          cfmsIdNo: item.cfmsIdNo ?? "",
          conClgName: item.conClgName ?? "",
          collegeAssigned: InstName ?? "",
          fromDateInsp: item.fromDateInsp ?? "",
          toDateInsp: item.toDateInsp ?? "",
          mobileNo: item.mobileNo ?? "",
        };
      })
      .filter(Boolean);

    const payload = {
      collCode: Number(collCode),
      nocType: degreeUniFormik.values.nocType,
      teamData,
    };

    Swal.fire({
      text: "Are you sure you want to submit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel!",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        CommonAxiosPost(`${config.url.FAC_URL}saveInspectionAllotement`, payload)
          .then((res) => {
            if (res?.data?.scode === "01") {
              successAlert2(res?.data?.sdesc || "Submitted successfully");
              setShowModal(false);
              GetInspectionStatus();
            } else {
              failureAlert(res?.data?.sdesc || "Submission failed");
            }
          })
          .catch(() => failureAlert("Something went wrong"));
      }
    });
  };

  // ─── Other API functions ─────────────────────────────────────────────────────

  function getSocietyNameDetails(collCode) {
    const url = `${config.url.FAC_URL}getSocietyNameChangeinspection/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.societyName_status === true) setSocietyName(res?.data?.societyName || []);
        else setSocietyName([]);
      })
      .catch(() => setSocietyName([]));
  }

  function handleAccomidations(collCode) {
    let url = `${config.url.FAC_URL}getAccommodationAreaData/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) setAccom(res.data.data || []);
        else setAccom([]);
      })
      .catch(() => setAccom([]));
  }

  function getShiftingScrutinyDetails(collCode, nocType) {
    let url = config.url.FAC_URL + `getScrutinyDetails/${collCode}/${nocType}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) setPdfData1(res.data);
        else setPdfData1({});
      })
      .catch(() => setPdfData1({}));
  }

  function finalGetAfterSubmit(collCode) {
    let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        const data = res?.data?.data;
        if (data && data.length > 0) {
          setPdfData2(data);
          setOverallData(res.data);
        } else {
          setOverallData([]);
        }
      })
      .catch(() => { });
  }

  function getShiftingAddDetails(collCode) {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res.data.data || [];
          if (shiftData.length > 0) setPdfData3(res.data);
        }
        else {
          sedPdfData3('');
        }
      })
  }

  function getShiftingAddDetailsss(collCode) {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res?.data?.data || [];
          if (shiftData.length > 0) {
            const firstShift = shiftData[0];
            setShiftAddr({
              new_mandal: firstShift.mandal_name || firstShift.new_mandal,
              new_district: firstShift.new_dist || firstShift.new_district,
              new_pincode: firstShift.new_pincode,
              address_ofnew_location: firstShift.address_ofnew_location,
              shift_type: firstShift.shift_type,
              distance_from_existing: firstShift.distance_from_existing,
              justification: firstShift.justification,
            });
          } else {
            setShiftAddr([]);
          }
        } else {
          setShiftAddr([]);
        }
      })
      .catch(() => setShiftAddr([]));
  }

  function getInspectionPdf(collCode, nocType) {
    CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetailspdf/${collCode}/${nocType}`)
      .then((res) => {
        const base64Pdf = res?.data?.pdf;
        if (base64Pdf) downloadBase64Pdf(base64Pdf, `${collCode}_inspection_report.pdf`);
      })
      .catch((err) => console.error("Error:", err));
  }

  async function openNewCollegeScrutinyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found.");
      return;
    }
    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked.");
      return;
    }
    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family:Arial,sans-serif;padding:24px;'>Generating scrutiny report PDF...</p>");
    try {
      const [collegeResponse, scrutinyResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getCollegeDetailsById?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDataForNewAc?collCode=${collCode}`),
      ]);
      const clgDetails = collegeResponse?.data || {};
      const scrutinyData = scrutinyResponse?.data || {};
      setScrutinyPdfData(clgDetails);
      setScrutinyPdfData1(scrutinyData);
      setSelectedRow(row);
      await openScrutinyPdfInNewTab({ clgDetails, scrutinyData, rowData: row, previewWindow });
    } catch (error) {
      previewWindow.close();
      failureAlert("Failed to generate scrutiny report PDF.");
    }
  }

  const getSurveyNumberr = async (collCode) => {
    let url = config.url.FAC_URL + "getlandDetailsScrutinyShitfing/" + collCode;
    try {
      const res = await CommonAxiosGet(url);
      if (res?.data?.status === true) setSurvey(res.data.data[0] || res.data.data || []);
      else setSurvey([]);
    } catch (err) {
      setSurvey([]);
    }
  };

  async function openManagementScrutinyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found.");
      return;
    }
    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked.");
      return;
    }
    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family:Arial,sans-serif;padding:24px;'>Generating management scrutiny report PDF...</p>");
    try {
      const [societyResponse, accommodationResponse, managementResponse, previewResponse, scrutinyDetailsResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getSocietyNameChangeinspection/${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getAccommodationAreaData/${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getManagementScrutiny?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getPreView?collCode=${collCode}&nocType=management`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetails/${collCode}/management`),
      ]);
      const societyData = societyResponse?.data?.societyName_status === true ? societyResponse?.data?.societyName || [] : [];
      const accommodationData = accommodationResponse?.data?.status === true ? accommodationResponse?.data?.data || [] : [];
      const managementPayload = managementResponse?.data?.scode === "01" ? managementResponse?.data || {} : {};
      const previewData = previewResponse?.data?.scode === "01" ? previewResponse?.data || {} : {};
      const scrutinyDetails = scrutinyDetailsResponse?.data?.status === true ? scrutinyDetailsResponse?.data || {} : {};
      setSocietyName(societyData);
      setAccom(accommodationData);
      setManagementData(managementPayload);
      setNocdata(previewData);
      await openChangeOfManagementPdfInNewTab({
        collCode,
        societyName: societyData,
        formValues: {},
        managementData: managementPayload,
        scrutinyDetails,
        mngmtScrutiny: managementPayload?.mngmtScrutiny || [],
        deficiencies: managementPayload?.mngmtScrutiny_def || [],
        accommodationRows: managementPayload?.mngmtScrutiny_accom || [],
        accommodationBaseRows: accommodationData,
        corpusFundInstall: scrutinyDetails?.corpusFundInstall || [],
        ugPrograms: scrutinyDetails?.ugCourses || [],
        pgPrograms: scrutinyDetails?.pgCourses || [],
        ugCorpusFunds: [],
        pgBefore: [],
        pgCorpusFunds: [],
        nocdata: previewData,
        parking: {},
        previewWindow,
      });
    } catch (error) {
      previewWindow.close();
      failureAlert("Failed to generate management scrutiny report PDF.");
    }
  }

  function getGovtStatusFile(row) {
    return row?.final_pdf_sign || "";
  }

  function hasGovtStatusFile(row) {
    const f = getGovtStatusFile(row);
    return f !== null && f !== undefined && String(f).trim() !== "";
  }

  function handlePost(row, index) {
    const rowValues = degreeUniFormik.values?.collegesTableData?.[index] || {};
    const govtFile = rowValues.govtFile || null;
    const isJdAdmin = userId === "jd_admin";
    const isSectionAdmin = userId === "section_admin";
    let payload;
    if (isSectionAdmin) {
      payload = { collCode: row.coll_code || "", nocType: row.noc_type || "", finalStatus: rowValues.final_status || "", finalPdf: row.final_pdf_sign, finalPdfSign: govtFile };
    } else {
      payload = { collCode: row.coll_code || "", nocType: row.noc_type || "", inspectionStatus: row.final_status || "", jdStatus: rowValues.jdStatus || "" };
    }
    if (isJdAdmin && !payload.jdStatus) {
      failureAlert("Please select JD Status");
      return;
    }
    const endpoint = userId === "section_admin" ? "updatesectionstatus" : "updatejdstatus";
    CommonAxiosPost(`${config.url.FAC_URL}${endpoint}`, payload)
      .then((res) => {
        if (res?.data?.ResponseCode === "01" || res?.data?.status === true) {
          if (payload?.jdStatus === "Recommended for Physical Verification") {
            Swal.fire({
              icon: "success",
              title: res?.data?.ResponseDesc || "Submitted successfully",
              backdrop: false,
              html: `<div style="font-size:14px;line-height:1.6;"><span id="assignInspectionLink" style="color:#0d6efd;text-decoration:underline;cursor:pointer;font-weight:600;">Click here to Assign Inspection Team</span></div>`,
              confirmButtonText: "Close",
              didOpen: () => {
                document.getElementById("assignInspectionLink")?.addEventListener("click", () => {
                  Swal.close();
                  navigate("/UniversityAssigningInspection");
                });
              },
            });
          } else {
            successAlert2(res?.data?.ResponseDesc || "Submitted successfully");
          }
          GetInspectionStatus();
          degreeUniFormik.setFieldValue("collegesTableData", []);
        } else {
          failureAlert(res?.data?.sdesc || "Failed to submit");
        }
      })
      .catch(() => failureAlert("Something went wrong!"));
  }

  async function getProceedingsDetails(collCode, noctype) {
    try {
      const res = await CommonAxiosGet(`${config.url.FAC_URL}shiftingallotteampdf/${collCode}/${noctype}`);
      if (res?.data?.status !== true) {
        failureAlert("Failed to fetch PDF.");
        return;
      }
      const base64Pdf = res?.data?.file;
      if (!base64Pdf) {
        failureAlert("No PDF data received.");
        return;
      }
      downloadBase64Pdf(base64Pdf, `${collCode}_college_Proceedings_report.pdf`);
    } catch (err) {
      failureAlert("Failed to load PDF.");
    }
  }

  function GetjdProceeding(collCode, nocType, jdstatus) {
    const type = nocType?.toLowerCase();
    const status = jdstatus?.toLowerCase();
    let url;
    if (jdstatus === "Deficiencies Identified") {
      url = `${config.url.FAC_URL}generateDeficiencyPdf/${collCode}/${nocType}`;
    } else if (type === "management" && (status === "approved" || status === "conditionally approved")) {
      url = `${config.url.FAC_URL}managementproceedings/${collCode}/${nocType}`;
    } else if (type === "eop" && (status === "approved" || status === "conditionally approved")) {
      url = `${config.url.FAC_URL}eopproceedings/${collCode}/${nocType}`;
    }
    if (!url) {
      failureAlert("No proceedings available for this status.");
      return;
    }
    CommonAxiosGet(url)
      .then((res) => {
        if ((res?.data?.scode === "01" && res?.data?.pdf) || (res?.data?.status === true && res?.data?.file)) {
          setPdfBase64(res.data.pdf || res.data.file);
          setShowPdfModal(true);
        } else {
          failureAlert("PDF not available.");
        }
      })
      .catch(() => failureAlert("Failed to load PDF."));
  }


  const [inspphysicaldata, setInspphysicaldata] = useState([]);
  function InspPhysicalsubmittedData(collCode) {
    const url = `${config.url.FAC_URL}getPhysicalCommiteeData/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          setInspphysicaldata(res.data.data || [])
        }
        else {
          setInspphysicaldata('');
        }
      })
  }



  function GetInspectionStatus() {
    const endpoint = userId === "section_admin" ? "getsectionadmindata" : "getInspectionStatus";
    CommonAxiosGet(`${config.url.FAC_URL}${endpoint}`).then((res) => {
      setInspStatus(res?.data?.scode === "01" ? res.data.data || [] : []);

      const fetchedData = res.data.data || [];
      const initialTableData = fetchedData.map((row) => ({
        ...row,
        jd_status: null,
        final_status: row.final_status || "",
        jdStatus: "",
      }));
      degreeUniFormik.setFieldValue("collegesTableData", initialTableData);
    });
  }
  useEffect(() => {
    GetInspectionStatus();
    GetNocServices();
  }, []);

  // ─── Styles ──────────────────────────────────────────────────────────────────
  const iconBtn = { border: "none", padding: "6px 10px", borderRadius: "6px", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center" };
  const previewBtn = { ...iconBtn, backgroundColor: "#e0f2fe", color: "#0284c7" };
  const downloadBtn = { ...iconBtn, backgroundColor: "#e6f9f0", color: "#059669" };
  const statusBadge = {
    backgroundColor: "#dcfce7",
    color: "#15803d",
    padding: "4px 12px",
    borderRadius: "999px",
    fontSize: "12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    width: "fit-content",
    maxWidth: "100%",
    whiteSpace: "nowrap",
  };

  const filteredInspectionStatus = degreeUniFormik?.values.nocType
    ? inspstatus.filter((item) => String(item?.noc_type || "").toLowerCase() === String(degreeUniFormik?.values?.nocType).toLowerCase())
    : inspstatus;


  const Columns = [
    { id: "slNo", header: "Sl.No", cell: ({ row }) => row.index + 1 },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "inst_name",
      header: "College Name",
      accessorKey: "inst_name",
      cell: ({ row }) => (
        <div style={{ textAlign: "left" }}>{row.original.inst_name}</div>
      ),
    },
    {
      id: "mobile_email",
      header: "Contact Details",
      cell: ({ row }) => (
        <div style={{ textAlign: "left" }}>
          {row.original.mobile_no} <br /> {row.original.email}
        </div>
      ),
    },
    {
      id: "college_preview",
      header: "College Preview",
      cell: ({ row }) => {
        const clgcode = row.original;
        const nocType = row.original.noc_type?.toLowerCase();
        const isNewCollege = nocType === "new_college";
        const collCode = row.original.coll_code;
        return (
          <button
            style={previewBtn}
            title="View College"
            onClick={() => {
              if (isNewCollege) {
                setSelectedCollCode(collCode);
                setShowPreview(true);
              } else {
                navigate("/CollegeDetails", { state: { clgcode } });
              }
            }}
          >
            <FaEye />
          </button>
        );
      },
    },
    {
      id: "inspection_preview",
      header: "Inspection Preview",
      cell: ({ row }) => {
        const nocType = row.original.noc_type?.toLowerCase();
        const collCode = row.original.coll_code;
        const isShifting = nocType === "shifting";
        const isEOP = nocType === "eop";
        const isNewCollege = nocType === "new_college";
        const isManagement = nocType === "management";
        const handleView = async () => {
          if (isShifting) {
            setSelectedCollCode(collCode);
            setShowShiftingModal(true);
            getShiftingScrutinyDetails(collCode, nocType);
            finalGetAfterSubmit(collCode);
            setSelectedRow(row.original);
            getSurveyNumberr(collCode);
            getShiftingAddDetails(collCode);
            getShiftingAddDetailsss(collCode);
          } else if (isEOP) {
            getInspectionPdf(collCode, nocType);
          } else if (isNewCollege) {
            openNewCollegeScrutinyPdf(row.original);
          } else if (isManagement) {
            openManagementScrutinyPdf(row.original);
          } else {
            setSelectedRow(row.original);
          }
        };
        return (
          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
            <button style={previewBtn} onClick={handleView} title="View Inspection">
              <FaEye />
            </button>
          </div>
        );
      },
    },

    // Conditional: section_admin + shifting
    ...(userId === "section_admin" &&
      degreeUniFormik?.values?.nocType === "shifting"
      ? [
        {
          id: "physical_team_data",
          header: "Assigned Team Member-Physical Committee",
          accessorKey: "physical_team_data",
          cell: ({ row }) => {
            const physicalTeamData = row?.original?.physical_team_data;
            return physicalTeamData ? (
              <>
                <span>{physicalTeamData}</span> &emsp;
                <FaDownload
                  style={{ cursor: "pointer", fontSize: "18px", color: "green" }}
                  title="Download Proceedings"
                  onClick={() =>
                    getProceedingsDetails(
                      row?.original?.coll_code,
                      row?.original?.noc_type
                    )
                  }
                />
              </>
            ) : (
              "-"
            );
          },
        },
      ]
      : []),

    // Status column
    {
      id: "status",
      header: userId === "section_admin" ? "JD Status" : "Status",
      accessorKey: userId === "section_admin" ? "jd_status" : "final_status",
      meta: { style: { textAlign: "left" } },
      cell: ({ row }) => (
        <div style={userId === "section_admin" ? {} : statusBadge}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {userId === "jd_admin" && (
              <span>{`Assigned to ${row?.original?.user_name}-${row?.original?.user_id}`}</span>
            )}
            {userId === "section_admin"
              ? row.original.jd_status
              : (() => {
                const finalStatus = row.original.final_status;
                const label =
                  finalStatus === "DeficiencyIdentified"
                    ? "Deficiency Identified"
                    : finalStatus === "NoDeficienciesIdentified"
                      ? "No Deficiencies Identified"
                      : finalStatus === "Rejected"
                        ? "Rejected"
                        : finalStatus;

                const color =
                  label === "Rejected"
                    ? "#e43408"
                    : label === "Deficiency Identified"
                      ? "#8a4837"
                      : label === "No Deficiencies Identified"
                        ? "#1c5c0c"
                        : "#313131";

                return (
                  <span style={{ fontWeight: "bold", color }}>{label}</span>
                );
              })()}
            {userId === "section_admin" &&
              row.original.noc_type !== "shifting" && (
                <button
                  style={{ ...previewBtn, marginLeft: "8px" }}
                  title="View Proceedings"
                  onClick={() =>
                    GetjdProceeding(
                      row.original.coll_code,
                      row.original.noc_type,
                      row.original.jd_status
                    )
                  }
                >
                  <FaEye />
                </button>
              )}
          </div>
        </div>
      ),
    },

    // Conditional: jd_admin + shifting → Assign Inspection + Committee Members
    ...(userId === "jd_admin" &&
      degreeUniFormik?.values?.nocType === "shifting"
      ? [
        {
          id: "assignInspection",
          header: "Assign Inspection",
          cell: ({ row }) =>
            row.original.noc_type === "shifting" &&
              row.original.jd_status === "Recommended for Physical Verification" ? (
              <span
                className="text-primary"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                role="button"
                tabIndex={0}
                onClick={() => {
                  setInstName(row.original.inst_name);
                  setcollcode(row.original.coll_code);
                  setVerificationType("physical_committee");
                  setAssignedTeamData({
                    online: row.original.online_team_data || "",
                    physical: row.original.physical_team_data || "",
                  });
                  GetTeamMembersData(row.original.coll_code);
                  getConvenerData();
                  getPolyData();
                  setShowModal(true);
                  degreeUniFormikAssignInspFormik.resetForm();
                  setTeamStaffdata({});
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setInstName(row.original.inst_name);
                    setcollcode(row.original.coll_code);
                    setVerificationType("physical_committee");
                    setAssignedTeamData({
                      online: row.original.online_team_data || "",
                      physical: row.original.physical_team_data || "",
                    });
                    GetTeamMembersData(row.original.coll_code);
                    getConvenerData();
                    getPolyData();
                    setShowModal(true);
                    degreeUniFormikAssignInspFormik.resetForm();
                    setTeamStaffdata({});
                  }
                }}
              >
                Click Here
              </span>
            ) : (
              "-"
            ),
        },
        {
          id: "committee_members",
          header: "Assigned Team Details",
          accessorKey: "committee_members",
          cell: ({ row }) => {
            const committeeData = row.original.committee_members || "";
            const teamHead = committeeData
              .split(",")
              .find((item) => item.trim().startsWith("teamHead:"));
            const teamMembers = committeeData
              .split(",")
              .filter((item) => item.trim().startsWith("teamMember:"));
            return (
              <div className="small">
                {teamHead && (
                  <div className="mb-2">
                    <span className="fw-bold text-primary">Team Head:</span>{" "}
                    {teamHead.replace("teamHead:", "").trim()}
                  </div>
                )}
                {teamMembers.length > 0 && (
                  <div>
                    <div className="fw-bold text-success mb-1">Members:</div>
                    <ul className="mb-0 ps-3">
                      {teamMembers?.map((member, index) => (
                        <li key={index}>{member.replace("teamMember:", "").trim()}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            );
          },
        },
      ]
      : []),

    // ✅ Action column — LAST base column
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => {
        const jdStatus = row?.original?.jd_status;
        const hasJdStatus =
          jdStatus !== null &&
          jdStatus !== undefined &&
          String(jdStatus).trim() !== "";
        if (userId === "jd_admin" && hasJdStatus)
          return (
            <span
              style={{
                color: "#15803d",
                fontSize: "13px",
                fontWeight: 600,
                display: "inline-block",
              }}
            >
              <FaCheck /> Already Submitted
            </span>
          );
        if (userId === "section_admin" && row.original.final_status)
          return (
            <span
              style={{
                color: "#15803d",
                fontSize: "13px",
                fontWeight: 600,
                display: "inline-block",
              }}
            >
              <FaCheck /> Already Submitted
            </span>
          );
        return (
          <button
            type="button"
            onClick={() => handlePost(row.original, row.index)}
            style={{
              backgroundColor: "#2563eb",
              color: "#fff",
              border: "none",
              padding: "6px 12px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
            }}
          >
            Submit
          </button>
        );
      },
    },
  ];

  // ✅ jd_admin: Insert JD Status BEFORE Action (second to last position)
  if (userId === "jd_admin") {
    Columns.splice(Columns.length - 1, 0, {
      id: "jd_status",
      header: "JD Status",
      cell: ({ row }) => {
        const index = row.index;
        const jdStatus = row.original.jd_status;
        const hasSubmittedStatus =
          jdStatus !== null &&
          jdStatus !== undefined &&
          String(jdStatus).trim() !== "";
        if (hasSubmittedStatus) {
          const normalizedStatus = jdStatus;
          const statusLabel =
            normalizedStatus === "approved"
              ? "Approved"
              : normalizedStatus === "Deficiencies Identified"
                ? "Deficiencies Identified"
                : normalizedStatus === "Reject"
                  ? "Rejected"
                  : jdStatus;
          const statusColor =
            normalizedStatus === "Approved" ||
              normalizedStatus === "Recommended for Physical Verification"
              ? "#15803d"
              : normalizedStatus === "Deficiencies Identified" ||
                normalizedStatus === "Reject"
                ? "#dc2626"
                : "";
          return (
            <div
              style={{
                minWidth: "180px",
                fontWeight: 600,
                color: statusColor,
                textAlign: "center",
              }}
            >
              <FaCheck /> {statusLabel}
            </div>
          );
        }
        return (
          <div style={{ minWidth: "180px" }}>
            <Field
              as="select"
              name={`collegesTableData[${index}].jdStatus`}
              className="form-control"
            >
              <option value="">Select</option>
              {row?.original?.noc_type === "shifting" ? (
                <>
                  <option value="Recommended for Physical Verification">
                    Recommended for Physical Verification
                  </option>
                  <option value="Reject">Reject</option>
                </>
              ) : (
                <>
                  <option value="Approved">APPROVED</option>
                  <option value="Deficiencies Identified">
                    DEFICIENCIES IDENTIFIED
                  </option>
                  <option value="Conditionally Approved">
                    CONDITIONALLY APPROVED
                  </option>
                </>
              )}
            </Field>
          </div>
        );
      },
    });
  }

  // ✅ jd_admin: Back to Scrutiny pushed AFTER Action (last)
  if (userId === "jd_admin") {
    Columns.push({
      id: "back_to_scrutiny",
      header: "Back to Scrutiny",
      cell: ({ row }) => {
        const BackCondition = row?.original?.jd_status;
        const handleBackToScrutiny = () => {
          const data = row.original;
          Swal.fire({
            title: "Do you want to Move Back to Scrutiny?",
            icon: "warning",
            html: `<div style="text-align:left"><p><b>College Name:</b> ${data?.inst_name
              ? `${data.inst_name}${data?.coll_code ? ` - ${data.coll_code}` : ""}`
              : "-"
              }</p><p><b>NOC Type:</b> ${data?.noc_type || "-"}</p></div>`,
            showCancelButton: true,
            confirmButtonText: "Yes, Move Back",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
          }).then((result) => {
            if (result.isConfirmed) {
              CommonAxiosPost(
                `${config.url.FAC_URL}backtoscrutiny`,
                { collCode: data?.coll_code, nocType: data?.noc_type }
              ).then((res) => {
                if (
                  res?.data?.ResponseCode === "01" ||
                  res?.data?.status === true
                ) {
                  successAlert2(res?.data?.ResponseDesc || "Moved to scrutiny");
                  GetInspectionStatus();
                } else {
                  failureAlert(res?.data?.sdesc || "Failed to update");
                }
              });
            }
          });
        };
        return (
          <>
            {!BackCondition && (
              <button
                className="btn btn-warning btn-sm"
                onClick={handleBackToScrutiny}
              >
                🔄 Back to Scrutiny
              </button>
            )}
          </>
        );
      },
    });
  }

  // ✅ section_admin: Insert Status dropdown before Action
  if (userId === "section_admin") {
    Columns.splice(Columns.length - 1, 0, {
      id: "final_status",
      header: "Status",
      cell: ({ row }) => {
        const index = row.index;
        return (
          <div style={{ minWidth: "180px" }}>
            {!row.original.final_status ? (
              <select
                className="form-control"
                name={`collegesTableData[${index}].final_status`}
                onChange={(e) =>
                  degreeUniFormik.setFieldValue(
                    `collegesTableData[${index}].final_status`,
                    e.target.value
                  )
                }
              >
                <option value="">-- Select --</option>
                <option value="Forwarded">Forward</option>
                <option value="BacktoJd">Back to JD</option>
              </select>
            ) : (
              <span style={{ color: "#228a62", fontWeight: 600 }}>
                {row.original.final_status || "No Status"}
              </span>
            )}
          </div>
        );
      },
    });
  }



  // ─── RENDER ──────────────────────────────────────────────────────────────────
  const officerOptions = (conData || [])
    .filter(
      (item) => !assignedTeamData.physical?.includes(item.principal_name)
    )
    .map((item) => ({
      value: item.principal_name,
      label: `${item.principal_name} - ${item.short_name_college}`,
      raw: item, // keep full object for easy lookup
    }));


  const polyOptions = (polyData || [])
    .filter(
      (item) => !assignedTeamData.physical?.includes(item.principal_name)
    )
    .map((item) => ({
      value: item.principal_name,
      label: `${item.principal_name} - ${item.inst_name} - ${item.dist}`,
      raw: item,
    }));


  return (
    <>
      {/* ✅ Modal wrapped in its OWN FormikProvider */}
      <FormikProvider value={degreeUniFormikAssignInspFormik}>
        <Form onSubmit={degreeUniFormikAssignInspFormik.handleSubmit}>
          <bie.Modal show={showModal} onHide={handleClose} size="xl" dialogClassName="custom-modal-width">
            <bie.Modal.Header closeButton style={{ backgroundColor: "#bbc2e9" }}>
              <bie.Modal.Title>Assigning Inspection Team to {InstName} College</bie.Modal.Title>
            </bie.Modal.Header>
            <bie.Modal.Body style={{ overflowX: "auto" }}>
              <FieldArray name="nonScrutinyModalFields">
                {() => (
                  <div style={{ overflowX: "auto" }}>
                    <h5 className="mb-3 innerheader-new">
                      <span>Committee Convenor Details</span>
                    </h5>
                    <table className="table table-bordered mt-2">
                      <thead className="table-primary">
                        <tr>
                          <th style={{ width: "180px" }}>University</th>
                          <th style={{ width: "180px" }}>Convenor Name with Department</th>
                          <th style={{ width: "140px" }}>Designation</th>
                          <th style={{ width: "150px" }}>Contact No</th>
                          <th style={{ width: "200px" }}>Email Id</th>
                          <th style={{ width: "160px" }}>CFMS id/Emp id</th>
                          <th style={{ width: "160px" }}>Convenor College Name</th>
                          <th style={{ width: "180px" }}>College Assigned</th>
                          <th style={{ width: "140px" }}>From Date</th>
                          <th style={{ width: "140px" }}>To Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[1].map((index) => (
                          <tr key={index}>
                            <td>
                              <Field
                                as="select"
                                name={`nonScrutinyModalFields[${index}].university`}
                                className="form-control"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].university`, value);
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].officerName`, "");
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].designation`, "");
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].gmail`, "");
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].cfmsIdNo`, "");
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].mobileNo`, "");
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].conClgName`, "");
                                  GetTeamStaffsData(value, index);
                                }}
                              >
                                <option value="">Select University</option>
                                {(teamMembersdata || []).map((item, idx) => (
                                  <option key={idx} value={item.ub_code}>
                                    {item.univ_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage name={`nonScrutinyModalFields[${index}].university`} component="div" className="text-danger" />
                            </td>

                            <td style={{ width: "30%" }}>
                              <Select
                                isDisabled={
                                  !degreeUniFormikAssignInspFormik.values.nonScrutinyModalFields[index]
                                    ?.university
                                }
                                options={(teamStaffsdata[index] || [])
                                  ?.filter(
                                    (item) =>
                                      !assignedTeamData.physical?.includes(item.fac_name)
                                  )
                                  .map((item) => ({
                                    value: item.fac_name,
                                    label: `${item.fac_name} - ${item.dept_name}`,
                                  }))}
                                value={
                                  (teamStaffsdata[index] || [])
                                    .map((item) => ({
                                      value: item.fac_name,
                                      label: `${item.fac_name} - ${item.dept_name}`,
                                    }))
                                    .find(
                                      (opt) =>
                                        opt.value ===
                                        degreeUniFormikAssignInspFormik.values.nonScrutinyModalFields[index]
                                          ?.officerName
                                    ) || null
                                }
                                onChange={(selected) => {
                                  handleOfficerChange(index, selected?.value || "");
                                }}
                              />

                              <ErrorMessage
                                name={`nonScrutinyModalFields[${index}].officerName`}
                                component="div"
                                className="text-danger"
                              />
                            </td>
                            <td>
                              <Field name={`nonScrutinyModalFields[${index}].designation`} className="form-control" disabled />
                              <ErrorMessage name={`nonScrutinyModalFields[${index}].designation`} component="div" className="text-danger" />
                            </td>
                            <td>
                              <Field name={`nonScrutinyModalFields[${index}].mobileNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled />
                              <ErrorMessage name={`nonScrutinyModalFields[${index}].mobileNo`} component="div" className="text-danger" />
                            </td>
                            <td>
                              <Field name={`nonScrutinyModalFields[${index}].gmail`} className="form-control" disabled />
                              <ErrorMessage name={`nonScrutinyModalFields[${index}].gmail`} component="div" className="text-danger" />
                            </td>
                            <td>
                              <Field name={`nonScrutinyModalFields[${index}].cfmsIdNo`} className="form-control" disabled />
                              <ErrorMessage name={`nonScrutinyModalFields[${index}].cfmsIdNo`} component="div" className="text-danger" />
                            </td>
                            <td>
                              <Field name={`nonScrutinyModalFields[${index}].conClgName`} className="form-control" disabled />
                              <ErrorMessage name={`nonScrutinyModalFields[${index}].conClgName`} component="div" className="text-danger" />
                            </td>
                            <td>
                              <input value={InstName} disabled className="form-control" />
                              <Field type="hidden" name={`nonScrutinyModalFields[${index}].collegeAssigned`} value={InstName} />
                            </td>
                            <td>
                              <Field
                                type="date"
                                name={`nonScrutinyModalFields[${index}].fromDateInsp`}
                                className="form-control"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].fromDateInsp`, value);
                                  [0, 2].forEach((i) => degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${i}].fromDateInsp`, value));
                                }}
                              />
                              <ErrorMessage name={`nonScrutinyModalFields[${index}].fromDateInsp`} component="div" className="text-danger" />
                            </td>
                            <td>
                              <Field
                                type="date"
                                name={`nonScrutinyModalFields[${index}].toDateInsp`}
                                className="form-control"
                                min={degreeUniFormikAssignInspFormik.values.nonScrutinyModalFields[index]?.fromDateInsp || ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${index}].toDateInsp`, value);
                                  [0, 2].forEach((i) => degreeUniFormikAssignInspFormik.setFieldValue(`nonScrutinyModalFields[${i}].toDateInsp`, value));
                                }}
                              />
                              <ErrorMessage name={`nonScrutinyModalFields[${index}].toDateInsp`} component="div" className="text-danger" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <h5 className="mb-3 innerheader-new">
                      <span>Team Member Details</span>
                    </h5>
                    <table className="table table-bordered mt-2">
                      <thead className="table-primary">
                        <tr>
                          <th>Member Details</th>
                          <th>Designation</th>
                          <th>Contact No</th>
                          <th>Email Id</th>
                          <th>CFMS id/Emp id</th>
                          <th>Member College Name</th>
                          <th>College Assigned</th>
                          <th>From Date</th>
                          <th>To Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ width: "20%" }}>
                            <Select
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,   // very high
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                              }}
                              name="nonScrutinyModalFields[0].officerName"
                              options={officerOptions}
                              isSearchable
                              placeholder="--Select--"
                              value={
                                officerOptions.find(
                                  (opt) =>
                                    opt.value ===
                                    degreeUniFormikAssignInspFormik.values
                                      .nonScrutinyModalFields?.[0]?.officerName
                                ) || null
                              }
                              onChange={(selected) => {
                                const selectedName = selected?.value || "";

                                degreeUniFormikAssignInspFormik.setFieldValue(
                                  "nonScrutinyModalFields[0].officerName",
                                  selectedName
                                );

                                const found = selected?.raw;

                                if (found) {
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[0].designation",
                                    found.designation || "-"
                                  );
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[0].gmail",
                                    found.email || ""
                                  );
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[0].mobileNo",
                                    found.mobile || ""
                                  );
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[0].conClgName",
                                    found.coll_name || ""
                                  );
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[0].cfmsIdNo",
                                    found.cfms_id || "-"
                                  );
                                }
                              }}
                            />

                            <ErrorMessage
                              name="nonScrutinyModalFields[0].officerName"
                              component="div"
                              className="text-danger"
                            />
                          </td>

                          <td><Field name="nonScrutinyModalFields[0].designation" className="form-control" disabled value="Principal" /><ErrorMessage name="nonScrutinyModalFields[0].designation" component="div" className="text-danger" /></td>
                          <td><Field name="nonScrutinyModalFields[0].mobileNo" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled /><ErrorMessage name="nonScrutinyModalFields[0].mobileNo" component="div" className="text-danger" /></td>
                          <td><Field name="nonScrutinyModalFields[0].gmail" className="form-control" disabled /><ErrorMessage name="nonScrutinyModalFields[0].gmail" component="div" className="text-danger" /></td>
                          <td><Field name="nonScrutinyModalFields[0].cfmsIdNo" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} /><ErrorMessage name="nonScrutinyModalFields[0].cfmsIdNo" component="div" className="text-danger" /></td>
                          <td><Field name="nonScrutinyModalFields[0].conClgName" className="form-control" disabled /><ErrorMessage name="nonScrutinyModalFields[0].conClgName" component="div" className="text-danger" /></td>
                          <td><input value={InstName} disabled className="form-control" /><Field type="hidden" name="nonScrutinyModalFields[0].collegeAssigned" value={InstName} /></td>
                          <td><Field type="date" name="nonScrutinyModalFields[0].fromDateInsp" className="form-control" disabled /><ErrorMessage name="nonScrutinyModalFields[0].fromDateInsp" component="div" className="text-danger" /></td>
                          <td><Field type="date" name="nonScrutinyModalFields[0].toDateInsp" className="form-control" disabled /><ErrorMessage name="nonScrutinyModalFields[0].toDateInsp" component="div" className="text-danger" /></td>
                        </tr>
                        {/* Row for index 2 — Poly principal */}
                        <tr>

                          <td style={{ width: "20%" }}>

                            <Select
                              options={polyOptions}
                              isSearchable
                              placeholder="--Select--"

                              value={
                                polyOptions.find(
                                  (opt) =>
                                    opt.value ===
                                    degreeUniFormikAssignInspFormik.values
                                      .nonScrutinyModalFields?.[2]?.officerName
                                ) || null
                              }

                              menuPortalTarget={document.body}
                              menuPosition="fixed"

                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                              }}

                              onChange={(selected) => {
                                const selectedName = selected?.value || "";

                                degreeUniFormikAssignInspFormik.setFieldValue(
                                  "nonScrutinyModalFields[2].officerName",
                                  selectedName
                                );

                                const found = selected?.raw;

                                if (found) {
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[2].designation",
                                    found.designation || "-"
                                  );
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[2].gmail",
                                    found.email_id || ""
                                  );
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[2].mobileNo",
                                    found.mobile || ""
                                  );
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[2].conClgName",
                                    found.inst_name || ""
                                  );
                                  degreeUniFormikAssignInspFormik.setFieldValue(
                                    "nonScrutinyModalFields[2].cfmsIdNo",
                                    found.cfms_id || "-"
                                  );
                                }
                              }}
                            />

                            <ErrorMessage
                              name="nonScrutinyModalFields[2].officerName"
                              component="div"
                              className="text-danger"
                            />
                          </td>

                          <td><Field name="nonScrutinyModalFields[2].designation" className="form-control" disabled value="Principal" /><ErrorMessage name="nonScrutinyModalFields[2].designation" component="div" className="text-danger" /></td>
                          <td><Field name="nonScrutinyModalFields[2].mobileNo" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled /><ErrorMessage name="nonScrutinyModalFields[2].mobileNo" component="div" className="text-danger" /></td>
                          <td><Field name="nonScrutinyModalFields[2].gmail" className="form-control" disabled /><ErrorMessage name="nonScrutinyModalFields[2].gmail" component="div" className="text-danger" /></td>
                          <td><Field name="nonScrutinyModalFields[2].cfmsIdNo" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} /><ErrorMessage name="nonScrutinyModalFields[2].cfmsIdNo" component="div" className="text-danger" /></td>
                          <td><Field name="nonScrutinyModalFields[2].conClgName" className="form-control" disabled /><ErrorMessage name="nonScrutinyModalFields[2].conClgName" component="div" className="text-danger" /></td>
                          <td><input value={InstName} disabled className="form-control" /><Field type="hidden" name="nonScrutinyModalFields[2].collegeAssigned" value={InstName} /><ErrorMessage name="nonScrutinyModalFields[2].collegeAssigned" component="div" className="text-danger" /></td>
                          <td><Field type="date" name="nonScrutinyModalFields[2].fromDateInsp" className="form-control" disabled /><ErrorMessage name="nonScrutinyModalFields[2].fromDateInsp" component="div" className="text-danger" /></td>
                          <td><Field type="date" name="nonScrutinyModalFields[2].toDateInsp" className="form-control" disabled /><ErrorMessage name="nonScrutinyModalFields[2].toDateInsp" component="div" className="text-danger" /></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </FieldArray>
              <div className="d-flex justify-content-end mt-3">
                <bie.Button type="submit" variant="success" onClick={handleSubmitWithTouch}>
                  Save Data
                </bie.Button>
              </div>
            </bie.Modal.Body>
          </bie.Modal>
        </Form>
      </FormikProvider>

      {/* PDF Preview Modal */}
      <bie.Modal
        show={showPdfModal}
        onHide={() => {
          setShowPdfModal(false);
          setPdfBase64("");
        }}
        size="xl"
        scrollable
      >
        <bie.Modal.Header closeButton>
          <bie.Modal.Title>Proceedings PDF</bie.Modal.Title>
        </bie.Modal.Header>
        <bie.Modal.Body>
          {pdfBase64 ? (
            <iframe src={`data:application/pdf;base64,${pdfBase64}`} width="100%" height="700px" title="Proceedings PDF" style={{ border: "none" }} />
          ) : (
            <p className="text-center text-danger">No PDF available.</p>
          )}
        </bie.Modal.Body>
      </bie.Modal>

      {/* Main page */}
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        {showPreview ? (
          <NewCollegeApplPreview collCode={selectedCollCode} />
        ) : (
          <FormikProvider value={degreeUniFormik}>
            <Form onSubmit={degreeUniFormik.handleSubmit} className="affl-form">
              <bie.Row className="px-2 pt-3 mb-3 w-100">
                <h5 className="mb-3 innerheader-new">
                  <span>Inspection Status</span>
                </h5>
                <bie.Row>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                    <label className="form-label mb-0" style={{ color: "#0f766e", fontWeight: 600, whiteSpace: "nowrap", marginBottom: 0 }}>
                      Select NOC Type
                    </label>
                    <Field as="select" name="nocType" className="form-control" onChange={(e) => degreeUniFormik.setFieldValue("nocType", e.target.value)}>
                      <option value="">--select--</option>
                      {/* <option value="eop">EOP</option>
                      <option value="new_college">New College</option>
                      <option value="management">Management Change</option>
                      <option value="shifting">Shifting</option>
                      <option value="conversion_program">Conversion</option> */}
                      {NocServicesOptions
                        ?.filter((service) => service.is_active)
                        .map((service) => (
                          <option
                            key={service.nos_short_name}
                            value={service.nos_short_name}
                          >
                            {service.full_name}
                          </option>
                        ))}
                    </Field>
                  </bie.Col>
                </bie.Row>
                <bie.Col xs={12}>
                  {filteredInspectionStatus?.length > 0 ? (
                    <div className="table-responsive">
                      <CommonReactTable
                        data={filteredInspectionStatus}
                        columns={Columns}
                        filename="InspectionStatus"

                        headerName={`Inspection Status - ${getServiceFullName(
                          degreeUniFormik?.values?.nocType,
                          NocServicesOptions
                        )}`}
                        showFooter={false}
                        showPagination={false}
                        showExcel={true}
                        showPrint={false}
                        excelFileName="Inspection Status"
                      />
                    </div>
                  ) : (
                    <center className="text-danger h6">*** No Data Found ***</center>
                  )}
                </bie.Col>

                <bie.Modal show={showShiftingModal} onHide={() => setShowShiftingModal(false)} size="xl" scrollable>
                  <bie.Modal.Header closeButton>
                    <bie.Modal.Title>{selectedRow?.noc_type === "shifting" && "Shifting Scrutiny Report"}</bie.Modal.Title>
                  </bie.Modal.Header>
                  <bie.Modal.Body>
                    {selectedRow?.noc_type === "shifting" && (
                      <CollegeReport apiData={pdfData} apiData2={pdfData2} rowData={selectedRow} getOverallData={getOverallData} getSurvey={getSurvey} newAddData={shiftAddr} />
                    )}
                  </bie.Modal.Body>
                </bie.Modal>
              </bie.Row>
            </Form>
          </FormikProvider>
        )}
      </bie.Container>
    </>
  );
}
